import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      // Anti-enumeration: server returns 200 even on unknown emails, so any
      // failure here is a network/transport issue, not "email not found".
      toast.error("Impossible d'envoyer la demande. Réessayez dans un instant.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="max-w-md mx-auto py-24 px-6 text-center">
        <p className="overline text-berulia-rosedeep">BERULIA</p>
        <h1 className="font-heading text-4xl mt-3">Vérifiez votre boîte mail ✿</h1>
        <p className="mt-6 text-berulia-inkmuted leading-relaxed">
          Si un compte existe pour <strong>{email}</strong>, un lien de réinitialisation
          vient d'y être envoyé. Le lien est valable 60 minutes.
        </p>
        <p className="mt-4 text-sm text-berulia-inkmuted">
          Pensez à vérifier les spams si vous ne voyez rien arriver.
        </p>
        <Link to="/connexion" className="mt-8 inline-block overline link-underline text-berulia-rosedeep">
          ← Retour à la connexion
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto py-24 px-6">
      <p className="overline text-berulia-rosedeep text-center">BERULIA</p>
      <h1 className="font-heading text-4xl text-center mt-3">Mot de passe oublié</h1>
      <p className="mt-4 text-center text-berulia-inkmuted text-sm leading-relaxed">
        Entrez votre adresse email. Nous vous enverrons un lien pour choisir un nouveau mot de passe.
      </p>

      <form onSubmit={submit} className="mt-10 space-y-5">
        <label className="block">
          <span className="overline text-berulia-inkmuted">Email</span>
          <input
            type="email"
            required
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="forgot-email"
            className="mt-1 w-full bg-white border border-berulia-border px-3 py-2 focus:border-berulia-ink outline-none"
          />
        </label>

        <button
          type="submit"
          disabled={loading}
          data-testid="forgot-submit"
          className="w-full bg-berulia-rosedeep text-berulia-inkdeep overline py-4 hover:bg-berulia-rose transition disabled:opacity-50"
        >
          {loading ? "Envoi en cours…" : "Envoyer le lien →"}
        </button>

        <p className="text-center text-sm text-berulia-inkmuted">
          <Link to="/connexion" className="link-underline">← Retour à la connexion</Link>
        </p>
      </form>
    </div>
  );
}
